import { TypoTooltip } from "@data-display/wrapper/DetectOverflow";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Chip, type ChipProps, Collapse, Stack } from "@mui/material";
import { type ReactNode, useState } from "react";

export interface IChipAccordionProps extends Omit<ChipProps, "children"> {
  label: string;
  children?: ReactNode;
}

export const ChipAccordion = ({ label, children, ...props }: IChipAccordionProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Stack sx={{ alignItems: "start" }}>
      <Chip
        {...props}
        color="primary"
        clickable
        label={
          <Stack sx={{ flexDirection: "row", alignItems: "center", gap: 1 }}>
            <TypoTooltip noWrap>{label}</TypoTooltip>
            {open ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
          </Stack>
        }
        onClick={() => setOpen((o) => !o)}
        size="small"
        sx={{ zIndex: 1 }}
      />
      <Collapse
        in={open}
        sx={(theme) => ({
          transform: `translateY(-${theme.spacing(1.5)})`,
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: theme.palette.primary.main,
          background: theme.palette.gray.light,
        })}
      >
        <Box
          sx={(theme) => ({
            marginTop: theme.spacing(1.5),
            padding: `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(2)}`,
          })}
        >
          {children}
        </Box>
      </Collapse>
    </Stack>
  );
};
